import { Grid, TextField, RadioGroup, FormControlLabel, Radio, Divider } from '@mui/material'
import Paragraph from '../../../../../../shared/UI/Paragraph'
import { RtwMaintenanceRequest } from '../../../../../../types/return-to-work'
import { boolToString, stringToBool } from '../../../../../../utils/rtwUtils'

type Props = {
  recurrent: boolean
  recurrentComments: string
  onFieldChange: (field: keyof RtwMaintenanceRequest, value: any) => void
}

function RecurrentSection({ recurrent, recurrentComments, onFieldChange }: Props) {
  return (
    <>
      <Grid item xs={12}>
        <Paragraph>Has this been recurrent?</Paragraph>
        <RadioGroup
          row
          aria-labelledby="recurrent-radio-group"
          name="recurrent-radio-group"
          value={boolToString(recurrent)}
          onChange={(e, checked) => {
            onFieldChange('recurrent', stringToBool(checked))
          }}
        >
          <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
          <FormControlLabel value="No" control={<Radio />} label="No" />
        </RadioGroup>
      </Grid>
      <Grid item xs={12} mt={2}>
        <TextField
          id="recurrent-additional-comment"
          label="Additional comment"
          variant="outlined"
          value={recurrentComments}
          onChange={(e) => onFieldChange('recurrentComments', e.target.value)}
          fullWidth
          sx={{ paddingBottom: '8px' }}
        />
        <Divider sx={{ margin: '30px 0' }} />
      </Grid>
    </>
  )
}

export default RecurrentSection